export default __webpack_public_path__ + "static/media/add.f49fedc5.svg";